module.exports = __webpack_public_path__ + "img/iphone69_screenshot-1.89eea0aa.jpeg";